import { bunja, createScope } from 'bunja';
import { atom } from 'jotai';

import { openPositionsBunja } from '@flipster/r230522/normal-sub/tables/private/positions';
import { accountBunja } from '@flipster/r230522/original/account';

/** profit boost 뱃지 하나가 담당하는 positionId 주입용 스코프. */
export const ProfitBoostPositionIdScope = createScope<string>();

/**
 * profit boost 뱃지 하나의 데이터 레이어 (ProfitBoostPositionIdScope로 스코프).
 * positionId로 self-subscribe하므로 뱃지에 통짜 position을 prop으로 넘길 필요가 없다.
 * - boostExpiryEpoch: 카운트다운 표시용. epoch(number)라 tick마다 새 Date 참조가 와도 값이 같으면 dedup.
 * - isOneWayMode: v2Account는 tick마다 새 객체지만 파생 boolean이라 Object.is dedup.
 * - position: 클릭 로깅용 통짜 객체는 핸들러에서 lazy read(useAtomCallback)한다 (구독 아님).
 */
export const profitBoostBadgeBunja = bunja(() => {
  const positionId = bunja.use(ProfitBoostPositionIdScope);
  const { openPositionByIdAtom } = bunja.use(openPositionsBunja);
  const { v2AccountAtom } = bunja.use(accountBunja);

  const positionAtom = atom((get) => get(openPositionByIdAtom)[positionId]);
  const boostExpiryEpochAtom = atom((get) => get(positionAtom)?.boostExpiryTimestamp?.getTime());
  const isOneWayModeAtom = atom((get) => get(v2AccountAtom)?.tradeMode === 'OneWay');

  return { positionAtom, boostExpiryEpochAtom, isOneWayModeAtom };
});
profitBoostBadgeBunja.debugLabel = 'profitBoostBadgeBunja';
